import { RecentActivitySliceState } from '../types/RecentActivitySliceState';

export const recentActivityInitialState: RecentActivitySliceState = {
  data: {
    listings: [],
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 20,
    },
  },
  savedFiltersForSending: null,
  statuses: {
    getRecentActivityList: {
      isLoading: false,
    },
  },
};
